/**
 * @generated SignedSource<<8846eb063354700142a4d46c73570480>>
 * @relayHash 534f8e942a7a9be603c661094407bcec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type useReactionMutationsDeleteReactionMutation$variables = {
  cloudId: string;
  containerId: AGG$Long;
  containerType: ContainerType;
  contentId: AGG$Long;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type useReactionMutationsDeleteReactionMutation$data = {
  readonly confluence_deleteReaction: {
    readonly ari: string | null | undefined;
    readonly containerAri: string | null | undefined;
    readonly emojiId: string | null | undefined;
  } | null | undefined;
};
export type useReactionMutationsDeleteReactionMutation = {
  response: useReactionMutationsDeleteReactionMutation$data;
  variables: useReactionMutationsDeleteReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiId"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "containerType",
            "variableName": "containerType"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentType",
            "variableName": "contentType"
          },
          {
            "kind": "Variable",
            "name": "emojiId",
            "variableName": "emojiId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceReactionPayload",
    "kind": "LinkedField",
    "name": "confluence_deleteReaction",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "ari"
      },
      {
        "kind": "ScalarField",
        "name": "containerAri"
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useReactionMutationsDeleteReactionMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "useReactionMutationsDeleteReactionMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "534f8e942a7a9be603c661094407bcec",
    "id": "e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b",
    "metadata": {},
    "name": "useReactionMutationsDeleteReactionMutation",
    "operationKind": "mutation",
    "text": "mutation useReactionMutationsDeleteReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_deleteReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
  }
};
})();

(node as any).hash = "026dd0e0d892c04c9adf5d33242807f3";

export default node;
